"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Profile = /** @class */ (function () {
    function Profile() {
        this.hasMasterPin = false;
    }
    return Profile;
}());
exports.Profile = Profile;
var VerificationResult;
(function (VerificationResult) {
    VerificationResult["VERIFIED"] = "verified";
    VerificationResult["FRAUD"] = "fraud";
})(VerificationResult = exports.VerificationResult || (exports.VerificationResult = {}));
//# sourceMappingURL=Profile.js.map